import { useShadowDom } from '../common';
export const useFeatureFlags = (...flags) => {
  var _injector$flags;

  const {
    injector
  } = useShadowDom();
  const featureFlags = (_injector$flags = injector.flags) != null ? _injector$flags : {};
  return flags.map(flag => featureFlags[flag] === 'on');
};